import { useMutation, useQuery } from '@tanstack/react-query';
import senderNamesService from '../services/senderNamesService';

export const useDeleteMultipleSenderNames = () => {
	return useMutation({
		mutationKey: ['senderNames'],
		mutationFn: (data: DeleteMultipleSenderNamesRequest[]) =>
			senderNamesService.deleteMultiple(data),
	});
};

export const useGetSingleSenderName = (
	senderNameID: number,
	options?: {
		isEnabled: boolean;
		getRelated?: string;
	},
) => {
	return useQuery<SenderName>({
		queryKey: ['senderName', senderNameID],
		queryFn: () =>
			senderNamesService.getSingleResource(senderNameID, {
				getRelated: options?.getRelated || '',
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetAllSenderNames = (options?: {
	filters?: string;
	isEnabled?: boolean;
}) => {
	return useQuery<TavoittajaApiResponse<{ senderNames: SenderName[] }>>({
		queryKey: ['senderNames'],
		queryFn: () =>
			senderNamesService.getAllResources({
				filters: options?.filters,
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useDeleteSenderName = () => {
	return useMutation({
		mutationKey: ['senderNames'],
		mutationFn: (id: number) => senderNamesService.deleteSingleResource(id),
	});
};

export const useUpdateSenderName = () => {
	return useMutation({
		mutationKey: ['senderNameUpdate'],
		mutationFn: (data: Partial<UpdateSenderNameRequest>) =>
			senderNamesService.update(data),
	});
};

export const useCreateSenderName = () => {
	return useMutation({
		mutationKey: ['senderNameCreate'],
		mutationFn: (data: Partial<CreateSenderNameRequest>) =>
			senderNamesService.create(data),
	});
};
